import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { NgbAlert, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, EMPTY, timer } from 'rxjs';
import { catchError, switchMap, takeWhile, tap } from 'rxjs/operators';
import { WoodTypificationComponent } from '../typification/wood-modal/wood-typification.component';
import { ImagemodalComponent } from '../imagemodal/imagemodal.component';
import { WaitingModalComponent } from '../waiting-modal/waiting-modal.component';
import { TableDataHandlerService } from './table-data-handler.service';
import { ImagemodalService } from '../imagemodal/imagemodal.service';
import { TypificationdatashareService } from '../typification/typificationdatashare.service';
import { RestclientService } from '../../services/restclient/restclient.service';
import { ClientDataService } from '../../services/auth/client.data.service';
import { TypimagesService } from '../typification/typimages.service';
import { debounceTime, repeat, delay } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { ConfigService } from 'src/app/services/config/config.service';
import { VersionCheckService } from 'src/app/services/update/version-check.service';
import { ContainerTypificationComponent } from '../typification/container-modal/container-typification.component';
import { LoadTypeSelectionModalComponent } from '../typification/load-type-selection-modal/load-type-selection-modal.component';
import { WdtkEvent, Vehicle, Bundle } from 'src/app/models/wdtk-event.model';

const FILTER_PAG_REGEX = /[^0-9]/g;
const MAIN = 'main';
const SECONDARY = 'secondary';

interface SelectedEvent {
  systemInfo: { systemStatus: string };
  params: { contentType: string; param: string; valueData: string }[];
}

interface DataRequestContext {
  seq: number;
  listType: 'main' | 'secondary';
  facilityId: number | string | undefined;
}

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
})
export class MainComponent implements OnInit {
  events$: Observable<any[]>;
  collectionSize$: Observable<number>;
  tableConfigs$: Observable<any[]>;
  facilityListUIX$: Observable<any[]>;
  activefacility$: Observable<any[]>;
  selectedEvent: SelectedEvent | undefined;
  activeFacility;
  buttonStatus = 0;

  page = 1;

  public mainlistactive: boolean = true;
  public secondlistactive: boolean = false;

  public noProblemFilter: boolean = false;
  public withProblemFilter: boolean = false;
  public measurementConflictFilter: boolean = false;
  public calculatedFilter: boolean = false;
  public straightAcceptedFilter: boolean = false;
  public sentFilter: boolean = false;
  public containerNoData: boolean = false;

  public acceptEventIcon = '../../../assets/icons/icons8_Checked_24px.png';
  public undoIcon = '../../../assets/icons/icons8-arrows-64.png';
  public calcIcon = '../../../assets/icons/icons8-calculadora-24.png';
  public sendIcon = '../../../assets/icons/icons8-exportar-32.png';
  public helpIcon = '../../../assets/icons/icons8-ayuda-50.png';
  public removeFiltersIcon =
    '../../../assets/icons/icons8-eliminar-filtros-50.png';

  public hasPriviledges: boolean = false;

  private _errorResponse = new Subject<string>();
  private _okResponse = new Subject<string>();

  public errorMessage = '';
  public okMessage = '';

  @ViewChild('selfClosingErrorAlert', { static: false })
  selfClosingErrorAlert: NgbAlert;
  @ViewChild('selfClosingOKAlert', { static: false })
  selfClosingOKAlert: NgbAlert;

  public alertCount = 0;

  private alertCountSuscription;
  private segEditNotifications;

  private notificationsStarted = false
  private dataRequestSeq = 0;
  private activeDataRequestContext: DataRequestContext | null = null;

  constructor(
    private modalService: NgbModal,
    public service: TableDataHandlerService,
    public imagespopup: ImagemodalService,
    public typificationshareservice: TypificationdatashareService,
    public restclient: RestclientService,
    private clientData: ClientDataService,
    private typImageService: TypimagesService,
    private cookieService: CookieService,
    private configService: ConfigService,
    private versionCheck: VersionCheckService
  ) {
    this.events$ = service.events$;
    this.collectionSize$ = service.total$;
    this.tableConfigs$ = service.tableConfigs$;
    this.facilityListUIX$ = clientData.uix_facility_list$;
    this.activefacility$ = clientData.active_facility$;
  }

  ngOnInit(): void {
    this._errorResponse.subscribe((message) => (this.errorMessage = message));
    this._errorResponse.pipe(debounceTime(5000)).subscribe(() => {
      if (this.selfClosingErrorAlert) {
        this.selfClosingErrorAlert.close();
      }
    });

    this._okResponse.subscribe((message) => (this.okMessage = message));
    this._okResponse.pipe(debounceTime(5000)).subscribe(() => {
      if (this.selfClosingOKAlert) {
        this.selfClosingOKAlert.close();
      }
    });

    //fetch main data from server
    //this.getData(MAIN);

    this.firstMainListAndNotificationsRequest();
    // load tip images
    this.typImageService.loadBundleImages();
    this.typImageService.loadTrailerImages();

    this.activefacility$.subscribe((facility) => {
      this.activeFacility = facility;
    });

    this.versionCheck.initVersionCheck();
  }

  ngOnDestroy(): void {
    this.stopNotification();
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload($event: any) {
    if (this.typificationshareservice.isActive()) {
      this.restclient
        .unlockEvent(this.typificationshareservice.wdtkEvent)
        .subscribe();
    }

    if (this.cookieService.check('segEditProfile')) {
      this.cookieService.delete('segEditProfile');
    }
  }

  open() {
    //console.log('open() method called');
    this.showWaiting();

    let truckClassification: string | undefined;
    let oEvent: WdtkEvent;
    let typConfig = {};

    this.restclient
      .getTypConfig()
      .pipe(
        tap((config) => {
          //console.log('TypConfig received:', config);
          this.typificationshareservice.setTypConfig(config);
          typConfig = config;
        }),
        switchMap(() => {
          //console.log('Fetching TypData for selectedEvent:', this.selectedEvent);
          return this.restclient.getTypData(this.selectedEvent!);
        }),
        tap((data) => {
          oEvent = data.oEvent;
          //console.log('TypData received:', data);

          // Store image URL if available
          const truckImageData = this.selectedEvent?.params.find(
            (data) => data.param === 'truck_image_url'
          );
          if (truckImageData) {
            this.typificationshareservice.setImageURL(truckImageData.valueData);
          }

          // Extract truck classification from backend
          truckClassification = oEvent.lm_data.main.params.param.find(
            (param: any) => param.name === 'truckClassification'
          )?.value;
          //console.log('Truck classification:', truckClassification);
        }),
        catchError((error) => {
          console.error('Error occurred during TypConfig or TypData fetch:', error);
          this.unlockEvent();
          this.hideWaiting();
          return this.handleError(error);
        })
      )
      .subscribe({
        next: async () => {
          try {
            //console.log('Determining modal to open based on truck classification');
            let result: any;
            let userSelectedTruckType: string;

            // Determine truck type and populate element params
            if (truckClassification === 'container truck') {
              //console.log('Opening Container Modal');
              this.typificationshareservice.setVehicleBundle(oEvent.lm_data.main.vehicles.vehicle);
              this.typificationshareservice.setWdtkEvent(oEvent);
              result = await this.openContainerModal();
            } else if (truckClassification === 'logs load truck') {
              //console.log('Opening Wood Modal');
              this.typificationshareservice.setVehicleBundle(oEvent.lm_data.main.vehicles.vehicle);
              this.typificationshareservice.setWdtkEvent(oEvent);
              result = await this.openWoodModal();
            } else {
              //console.log('Opening Load Type Selection Modal');
              const modalRef = this.modalService.open(
                LoadTypeSelectionModalComponent,
                { centered: true }
              );
              const selection = await modalRef.result;

              //console.log('Load Type Selection:', selection);
              // Map selection to truck type and populate params
              userSelectedTruckType = selection === 'A' ? 'logs load truck' : 'container truck';
              oEvent = this.populateElementParams(oEvent, userSelectedTruckType, typConfig);
              this.typificationshareservice.setVehicleBundle(oEvent.lm_data.main.vehicles.vehicle);
              this.typificationshareservice.setWdtkEvent(oEvent);

              result =
                selection === 'A'
                  ? await this.openWoodModal()
                  : await this.openContainerModal();
            }

            if (result !== null && result !== undefined) {
              //console.log('Handling post-typification with result:', result);
              await this.handlePostTypification(result);
            }
            else {
              this.unlockEvent();
            }

          } catch (error) {
            //console.log('Modal dismissed or error occurred:', error);
            this.unlockEvent();
          } finally {
            this.hideWaiting();
          }
        },
        error: (error) => {
          //console.log('Subscription error:', error);
          this.unlockEvent();
          this.hideWaiting();
        }
      });
  }

  /**
   * Populates element-level params in the lm_data structure based on truck type selection.
   * This ensures the bundle elements have the necessary param structure before opening modals.
   * 
   * @param oEvent - The lm_data object from the backend response
   * @param truckType - The truck type selected/determined: 'logs load truck' or 'container truck'
   * @returns The modified lm_data object with populated element params
   */
  private populateElementParams(oEvent: WdtkEvent, truckType: string, systemTypConfig): any {
    if (!oEvent || !oEvent.lm_data.main || !oEvent.lm_data.main.vehicles) {
      console.warn('Invalid lm_data structure:', oEvent);
      return oEvent;
    }

    oEvent.lm_data.main.params.param.push({ name: 'truckClassification', value: truckType });

    const vehicles = oEvent.lm_data.main.vehicles.vehicle || [];

    // Iterate through all vehicles
    vehicles.forEach((vehicle: Vehicle) => {
      // Only process trailer vehicles
      if (vehicle.type === 'trailer' && vehicle.elements && vehicle.elements.element) {
        // Iterate through all elements in the vehicle
        vehicle.elements.element.forEach((element: Bundle) => {
          // Initialize params.param as empty array if it doesn't exist or is empty
          if (!element.params.param) {
            element.params.param = [];
          }

          // Log that we're setting up the structure for params population
          console.log(`Populating element params for truck type: ${truckType} at element id: ${element.id}`);

          if (truckType === 'logs load truck') {
            element.params.param.push({ name: 'arrange', value: 'longitudinal' });
            element.model = {
              type: '',
              data: [{ name: '', value: '', factor: '', unit: '' }],
            };
          }

          if (truckType === 'container truck') {
            element.params.param.push({ name: 'arrange', value: systemTypConfig.loads[0].value });
            element.model = {
              type: 'unknown'
            };
          }
        });
      }
    });

    return oEvent;
  }

  private async openWoodModal(): Promise<any> {
    const modalRef = this.modalService.open(WoodTypificationComponent, {
      size: 'lg',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.componentInstance.name = 'TypificationComponent';

    try {
      // Handle the case when the modal is closed
      return await modalRef.result; // Resolves with the result of the modal
    } catch (error) {
      // Handle the case when the modal is dismissed
      //console.log('Wood Modal dismissed:', error);
      return null; // Return null or a specific value for dismiss
    }
  }

  private async openContainerModal(): Promise<any> {
    const modalRef = this.modalService.open(ContainerTypificationComponent, {
      size: 'lg',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.componentInstance.name = 'TypificationComponent';

    try {
      // Handle the case when the modal is closed
      return await modalRef.result; // Resolves with the result of the modal
    } catch (error) {
      // Handle the case when the modal is dismissed
      //console.log('Container Modal dismissed:', error);
      return null; // Return null or a specific value for dismiss
    }
  }

  private async handlePostTypification(result: any): Promise<void> {
    try {
      await this.restclient.postTypData(this.selectedEvent!, result).toPromise();

      const id_event = this.getParamValue('event_id');
      const ok = await this.restclient.segEditProfile().toPromise();

      const fechaExpiracion = new Date();
      fechaExpiracion.setMinutes(
        fechaExpiracion.getMinutes() + this.configService.segEditTimeOut
      );

      this.cookieService.set(
        'segEditProfile',
        ok.temp_access_token,
        fechaExpiracion,
        '/',
        this.configService.domain,
        this.configService.secure
      );

      const segedit_url = `${this.configService.segEditUrl}/event/${id_event}`;
      this.hideWaiting();
      window.open(segedit_url);
    } catch (error) {
      //console.log('Error completo:', error);
      this.hideWaiting();
      const id_event = this.getParamValue('event_id');
      if (error.status === 410) {
        this._errorResponse.next(
          `El evento ${id_event}, fue previamente liberado por exceder el tiempo de espera...`
        );
      }

      if (error.status === 500) {
        this._errorResponse.next(
          `${error.error.message}`
        );
        this.unlockEvent();
      }



    }
  }

  private unlockEvent(): void {
    this.restclient.unlockEvent(this.selectedEvent!).subscribe(
      () => {
        this.hideWaiting();
        this.getData(MAIN);
      },
      (error) => {
        this.hideWaiting();
        if (error.status === 410) {
          const id_event = this.getParamValue('event_id');
          this._errorResponse.next(
            `El evento ${id_event}, fue previamente liberado por exceder el tiempo de espera...`
          );
        }
      }
    );
  }

  private handleError(error: any): Observable<never> {
    this.hideWaiting();

    const id_event = this.getParamValue('event_id');

    if (error.status === 423) {
      this._errorResponse.next(
        `El evento ${id_event} ha sido tomado por otro usuario, la lista de eventos ha sido actualizada`
      );
      this.getData(MAIN);
    } else if (error.status === 500) {
      this._errorResponse.next(
        `El evento ${id_event} no se encuentra disponible en la nube...`
      );
    } else {
      console.error(error);
    }

    return EMPTY;
  }

  private getParamValue(paramName: string): string | undefined {
    const param = this.selectedEvent?.params.find((p) => p.param === paramName);
    return param?.valueData;
  }

  private getEventIdFromSelectedEvent(
    event?: SelectedEvent
  ): string | undefined {
    const param = event?.params.find((p) => p.param === 'event_id');
    return param?.valueData;
  }

  private getButtonStatusFromSelectedEvent(event?: SelectedEvent): number {
    const lastStateParam = event?.params.find((p) =>
      p.param.includes('last_state')
    );
    const lastState = Number(lastStateParam?.valueData);

    if (lastState === 0) {
      return 2;
    }

    if (lastState === 4 || lastState === 8) {
      return 1;
    }

    return 0;
  }

  private applySelectedEventState(event: SelectedEvent): void {
    this.service.setSelectedEvent(event);
    this.selectedEvent = event;
    this.buttonStatus = this.getButtonStatusFromSelectedEvent(event);
  }

  private reconcileSelectionAfterSnapshot(
    snapshotEvents: SelectedEvent[] | any[]
  ): void {
    const selectedEventId = this.getEventIdFromSelectedEvent(this.selectedEvent);

    if (!this.selectedEvent || !selectedEventId) {
      this.resetSelectionState();
      return;
    }

    const freshSelectedEvent = snapshotEvents.find(
      (event) => this.getEventIdFromSelectedEvent(event) === selectedEventId
    );

    if (freshSelectedEvent) {
      this.applySelectedEventState(freshSelectedEvent);
      return;
    }

    this.resetSelectionState();
  }

  send() {
    if (!this.selectedEvent) {
      return;
    }

    this.showWaiting();

    const selectedEvent = this.selectedEvent;
    const id_event = this.getParamValue('event_id');

    this.restclient.postSendEvent(selectedEvent).subscribe(
      (ok) => {
        this._okResponse.next(
          'El evento ' +
          id_event +
          ' espera ser enviado por el sistema Logmeter'
        );
        this.getData(MAIN, false);
      },
      (error) => {
        this.hideWaiting();
        if (error.status == 500) {
          this._errorResponse.next(
            'El evento ' +
            id_event +
            ' no se encuentra disponible para ser procesado...'
          );
        }
      }
    );
  }

  accept() {
    if (!this.selectedEvent) {
      return;
    }

    this.showWaiting();

    const selectedEvent = this.selectedEvent;
    const id_event = this.getParamValue('event_id');

    this.restclient.postAcceptEvent(selectedEvent).subscribe(
      (ok) => {
        this._okResponse.next(
          'El evento ' +
          id_event +
          ' espera ser aceptado por el sistema Logmeter'
        );
        this.getData(MAIN, false);
      },
      (error) => {
        this.hideWaiting();
        if (error.status == 500) {
          this._errorResponse.next(
            'El evento ' +
            id_event +
            ' no se encuentra disponible para ser procesado...'
          );
        }
      }
    );
  }

  undo() {
    if (!this.selectedEvent) {
      return;
    }

    this.showWaiting();

    const selectedEvent = this.selectedEvent;
    const id_event = this.getParamValue('event_id');

    this.restclient.postUndoEvent(selectedEvent).subscribe(
      (ok) => {
        this._okResponse.next(
          'El evento ' +
          id_event +
          ' espera que se deshaga el calculo por el sistema Logmeter'
        );
        this.getData(MAIN, false);
      },
      (error) => {
        this.hideWaiting();
        if (error.status == 500) {
          this._errorResponse.next(
            'El evento ' +
            id_event +
            ' no se encuentra disponible para ser procesado...'
          );
        }
      }
    );
  }

  showImage(event, eventImage) {
    let finalImageUrl = eventImage;
    if (eventImage.startsWith('/local_dataset_images')) {
      finalImageUrl = `${this.configService.loatWebBackend}${eventImage}`;
    }

    this.imagespopup.updateImageSource(finalImageUrl);

    const modalRef = this.modalService.open(ImagemodalComponent, {
      centered: true,
    });
    modalRef.componentInstance.name = 'ImagemodalComponent';
  }

  showWaiting() {
    const modalRef = this.modalService.open(WaitingModalComponent, {
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.name = 'WaitingModalComponent';
  }

  hideWaiting() {
    if (this.modalService.hasOpenModals) {
      this.modalService.dismissAll();
    }
  }

  private getActiveFacilityId(): number | string | undefined {
    const activeFacility = this.clientData.uix_facility_list.find(
      (facility) => facility['active'] == 1
    );

    return activeFacility?.id_facility;
  }

  private sameFacility(
    left: number | string | undefined,
    right: number | string | undefined
  ): boolean {
    if (left === undefined || right === undefined) {
      return left === right;
    }

    return String(left) === String(right);
  }

  private createDataRequestContext(list_type: string): DataRequestContext {
    return {
      seq: ++this.dataRequestSeq,
      listType: list_type.includes(SECONDARY) ? SECONDARY : MAIN,
      facilityId: this.getActiveFacilityId(),
    };
  }

  private isActiveListView(listType: 'main' | 'secondary'): boolean {
    if (listType === MAIN) {
      return this.mainlistactive;
    }

    return this.secondlistactive;
  }

  private isCurrentDataRequestContext(context: DataRequestContext): boolean {
    if (!this.activeDataRequestContext) {
      return false;
    }

    return (
      this.activeDataRequestContext.seq === context.seq &&
      this.activeDataRequestContext.listType === context.listType &&
      this.sameFacility(this.getActiveFacilityId(), context.facilityId) &&
      this.isActiveListView(context.listType)
    );
  }

  private resetSelectionState(): void {
    this.service.setSelectedEvent(undefined);
    this.selectedEvent = undefined;
    this.buttonStatus = 0;
  }

  private hideWaitingIfCurrent(context: DataRequestContext): void {
    if (this.isCurrentDataRequestContext(context)) {
      this.hideWaiting();
    }
  }

  noProblemFilterClick() {
    this.service.clearFilters();
    if (
      this.calculatedFilter == true ||
      this.straightAcceptedFilter == true ||
      this.sentFilter == true
    ) {
      this.calculatedFilter = false;
      this.straightAcceptedFilter = false;
      this.sentFilter = false;
    }

    if (this.withProblemFilter == true) {
      this.withProblemFilter = false;
    }

    if (
      this.measurementConflictFilter == true &&
      this.noProblemFilter == false
    ) {
      this.service
        .filterEvents('weight_volume_ratio_fulfilment', '✓')
        .subscribe((data) => {
          if (data.total > 0) {
            this.service.filterEvents('calc_error', '✗');
          }
        });
    }

    if (
      this.measurementConflictFilter == true &&
      this.noProblemFilter == true
    ) {
      this.service.filterEvents('weight_volume_ratio_fulfilment', '✓');
    }

    if (
      this.noProblemFilter == false &&
      this.measurementConflictFilter == false
    ) {
      this.service.filterEvents('calc_error', '✗');
    }

    this.noProblemFilter = !this.noProblemFilter;
  }

  withProblemFilterClick() {
    this.service.clearFilters();
    if (
      this.calculatedFilter == true ||
      this.straightAcceptedFilter == true ||
      this.sentFilter == true
    ) {
      this.calculatedFilter = false;
      this.straightAcceptedFilter = false;
      this.sentFilter = false;
    }

    if (this.noProblemFilter == true) {
      this.noProblemFilter = false;
    }

    if (
      this.measurementConflictFilter == true &&
      this.withProblemFilter == false
    ) {
      this.service
        .filterEvents('weight_volume_ratio_fulfilment', '✓')
        .subscribe((data) => {
          if (data.total > 0) {
            this.service.filterEvents('calc_error', '✓');
          }
        });
    }

    if (
      this.measurementConflictFilter == true &&
      this.withProblemFilter == true
    ) {
      this.service.filterEvents('weight_volume_ratio_fulfilment', '✓');
    }

    if (
      this.withProblemFilter == false &&
      this.measurementConflictFilter == false
    ) {
      this.service.filterEvents('calc_error', '✓');
    }

    this.withProblemFilter = !this.withProblemFilter;
  }

  measurementConflictFilterClick() {
    this.service.clearFilters();
    if (
      this.calculatedFilter == true ||
      this.straightAcceptedFilter == true ||
      this.sentFilter == true
    ) {
      this.calculatedFilter = false;
      this.straightAcceptedFilter = false;
      this.sentFilter = false;
    }

    if (
      this.withProblemFilter == true &&
      this.measurementConflictFilter == false
    ) {
      this.service.filterEvents('calc_error', '✓').subscribe((data) => {
        if (data.total > 0) {
          this.service.filterEvents('weight_volume_ratio_fulfilment', '✓');
        }
      });
    }

    if (
      this.withProblemFilter == true &&
      this.measurementConflictFilter == true
    ) {
      this.service.filterEvents('calc_error', '✓');
    }

    if (
      this.noProblemFilter == true &&
      this.measurementConflictFilter == false
    ) {
      this.service.filterEvents('calc_error', '✗').subscribe((data) => {
        if (data.total > 0) {
          this.service.filterEvents('weight_volume_ratio_fulfilment', '✓');
        }
      });
    }

    if (
      this.noProblemFilter == true &&
      this.measurementConflictFilter == true
    ) {
      this.service.filterEvents('calc_error', '✗');
    }

    if (
      this.measurementConflictFilter == false &&
      this.withProblemFilter == false &&
      this.noProblemFilter == false
    ) {
      this.service.filterEvents('weight_volume_ratio_fulfilment', '✓');
    }

    this.measurementConflictFilter = !this.measurementConflictFilter;
  }

  calculatedFilterClick() {
    this.service.clearFilters();
    if (
      this.noProblemFilter == true ||
      this.withProblemFilter == true ||
      this.measurementConflictFilter == true
    ) {
      this.noProblemFilter = false;
      this.withProblemFilter = false;
      this.measurementConflictFilter = false;
    }

    if (this.straightAcceptedFilter == true) {
      this.straightAcceptedFilter = false;
    }

    if (this.sentFilter == true && this.calculatedFilter == false) {
      this.service.filterEvents('sent', '1').subscribe((data) => {
        if (data.total > 0) {
          this.service.filterEvents('re_calculated', '1');
        }
      });
    }

    if (this.sentFilter == true && this.calculatedFilter == true) {
      this.service.filterEvents('sent', '1');
    }

    if (this.sentFilter == false && this.calculatedFilter == false) {
      this.service.filterEvents('re_calculated', '1');
    }

    this.calculatedFilter = !this.calculatedFilter;
  }

  straightAcceptedFilterClick() {
    this.service.clearFilters();
    if (
      this.noProblemFilter == true ||
      this.withProblemFilter == true ||
      this.measurementConflictFilter == true
    ) {
      this.noProblemFilter = false;
      this.withProblemFilter = false;
      this.measurementConflictFilter = false;
    }

    if (this.calculatedFilter == true) {
      this.calculatedFilter = false;
    }

    if (this.sentFilter == true && this.straightAcceptedFilter == false) {
      this.service.filterEvents('sent', '1').subscribe((data) => {
        if (data.total > 0) {
          this.service.filterEvents('re_calculated', '0');
        }
      });
    }

    if (this.sentFilter == true && this.straightAcceptedFilter == true) {
      this.service.filterEvents('sent', '1');
    }

    if (this.sentFilter == false && this.straightAcceptedFilter == false) {
      this.service.filterEvents('sent', '1').subscribe((data) => {
        if (data.total > 0) {
          this.service.filterEvents('re_calculated', '0');
        }
      });
    }

    this.straightAcceptedFilter = !this.straightAcceptedFilter;
  }

  sentFilterClick() {
    this.service.clearFilters();
    if (
      this.noProblemFilter == true ||
      this.withProblemFilter == true ||
      this.measurementConflictFilter == true
    ) {
      this.noProblemFilter = false;
      this.withProblemFilter = false;
      this.measurementConflictFilter = false;
    }

    if (this.sentFilter == false && this.calculatedFilter == true) {
      this.service.filterEvents('re_calculated', '1').subscribe((data) => {
        if (data.total > 0) {
          this.service.filterEvents('sent', '1');
        }
      });
    }

    if (this.sentFilter == true && this.calculatedFilter == true) {
      this.service.filterEvents('re_calculated', '1');
    }

    if (
      (this.sentFilter == false && this.straightAcceptedFilter == true) ||
      (this.sentFilter == true && this.straightAcceptedFilter == true)
    ) {
      this.service.filterEvents('sent', '1').subscribe((data) => {
        if (data.total > 0) {
          this.service.filterEvents('re_calculated', '0');
        }
      });
    }

    if (
      this.sentFilter == false &&
      this.straightAcceptedFilter == false &&
      this.calculatedFilter == false
    ) {
      this.service.filterEvents('sent', '1');
    }

    this.sentFilter = !this.sentFilter;
  }

  cointainerNoDataFilter() {
    this.service.clearFilters();
    if (
      this.noProblemFilter == true ||
      this.withProblemFilter == true ||
      this.measurementConflictFilter == true ||
      this.calculatedFilter == true ||
      this.straightAcceptedFilter == true ||
      this.sentFilter == true
    ) {
      this.noProblemFilter = false;
      this.withProblemFilter = false;
      this.measurementConflictFilter = false;
      this.calculatedFilter = false;
      this.straightAcceptedFilter = false;
      this.sentFilter = false;
    }

    if (this.containerNoData == false) {
      this.service.filterEvents('container_no_data', '1');
    }

    this.containerNoData = !this.containerNoData;
  }

  cleanFilters() {
    if (
      this.noProblemFilter == true ||
      this.withProblemFilter == true ||
      this.measurementConflictFilter == true ||
      this.calculatedFilter == true ||
      this.straightAcceptedFilter == true ||
      this.sentFilter == true ||
      this.containerNoData == true
    ) {
      this.noProblemFilter = false;
      this.withProblemFilter = false;
      this.measurementConflictFilter = false;
      this.calculatedFilter = false;
      this.straightAcceptedFilter = false;
      this.sentFilter = false;
      this.containerNoData = false;
      this.service.clearFilters();
    }
  }

  eventSelected(event, wdtkEventObject) {
    const selectedEvent = wdtkEventObject;

    this.applySelectedEventState(selectedEvent);
  }

  formatInput(input: HTMLInputElement) {
    input.value = input.value.replace(FILTER_PAG_REGEX, '');
  }

  selectPage(page: string) {
    this.service.page = parseInt(page, 10) || 1;
  }

  public checkFilters() {
    if (
      this.noProblemFilter ||
      this.withProblemFilter ||
      this.measurementConflictFilter ||
      this.calculatedFilter ||
      this.straightAcceptedFilter ||
      this.sentFilter ||
      this.containerNoData
    ) {
      return true;
    } else {
      return false;
    }
  }

  firstMainListAndNotificationsRequest() {
    this.showWaiting();
    this.restclient.getEventTableConfig().subscribe(
      (data) => {
        this.service.setTableRender(data);
      },
      (error) => {
        //console.error(error);
        this.hideWaiting();
      },
      () => {
        this.restclient.getUIXFacilityList().subscribe(
          (data) => {
            this.clientData.setUixFacilityList(data);
          },
          (error) => console.error(error),
          () => {
            this.restclient.getMainEventTableData().subscribe(
              (data) => {
                //console.log(data.events);
                this.service.startService(data.events);
                this.alertCount = Number(data.notification || data.notifications || 0);
                //console.log("checking new events or status updates from: "+data.timestamp);
                this.startNotification(data.timestamp);
              },
              (error) => {
                console.error(error);
              },
              () => this.hideWaiting()
            );
          }
        );
      }
    );
  }

  /**
   * fetch data and properties to draw the table, has 2 posible values
   * * main - get the main list
   * * secondary - get the secondary list
   */
  private getData(list_type: string, showWaitingModal = true) {
    const requestContext = this.createDataRequestContext(list_type);
    this.activeDataRequestContext = requestContext;

    if (showWaitingModal) {
      this.showWaiting();
    }

    this.restclient.getEventTableConfig().subscribe(
      (data) => {
        //console.log(data);
        this.service.setTableRender(data);
      },
      (error) => {
        //console.error(error);
        this.hideWaitingIfCurrent(requestContext);
      },

      () => {
        this.restclient.getUIXFacilityList().subscribe(
          (data) => {
            this.clientData.updateUixFacilityList(data);
          },
          (error) => {
            console.error(error);
            this.hideWaitingIfCurrent(requestContext);
          },
          () => {
            if (list_type.includes(MAIN)) {
              this.stopNotification();
              this.restclient.getMainEventTableData().subscribe(
                (data) => {
                  if (!this.isCurrentDataRequestContext(requestContext)) {
                    return;
                  }

                  this.service.startService(data.events);
                  this.reconcileSelectionAfterSnapshot(data.events);
                  this.alertCount = Number(data.notification || data.notifications || 0);
                  this.startNotification(data.timestamp);
                  this.hideWaiting();
                },
                (error) => {
                  console.error(error);
                  this.hideWaitingIfCurrent(requestContext);
                },
              );
            }
            if (list_type.includes(SECONDARY)) {
              this.restclient.getSecondaryEventTableData().subscribe(
                (data) => {
                  if (!this.isCurrentDataRequestContext(requestContext)) {
                    return;
                  }

                  this.service.startService(data.events);
                  this.reconcileSelectionAfterSnapshot(data.events);
                  this.hideWaiting();
                },

                (error) => {
                  console.error(error);
                  this.hideWaitingIfCurrent(requestContext);
                },
              );
            }
          }
        );
      }
    );
  }

  getPrimaryList() {
    if (this.mainlistactive == false && this.secondlistactive == true) {
      this.mainlistactive = true;
      this.secondlistactive = false;
    }

    this.getData(MAIN);
  }

  getSecondaryList() {
    if (this.mainlistactive == true && this.secondlistactive == false) {
      this.mainlistactive = false;
      this.secondlistactive = true;
    }

    this.getData(SECONDARY);
  }

  onFacilityChange(event, _facility) {
    //check list
    //get the new facility event list

    this.clientData.changeActiveFacility(_facility);

    if (this.mainlistactive) {
      this.getData(MAIN);
    }

    if (this.secondlistactive) {
      this.getData(SECONDARY);
    }
  }

  startNotification_old(timestamp) {
    if (this.alertCountSuscription == undefined) {
      this.alertCountSuscription = this.restclient
        .getNotifications(timestamp)
        .pipe(delay(5000), repeat())
        .subscribe((response) => {
          //console.log(response);
          this.alertCount = response;
        });
    } else {
      this.alertCount = 0;
      this.alertCountSuscription.unsubscribe();

      this.alertCountSuscription = this.restclient
        .getNotifications(timestamp)
        .pipe(delay(5000), repeat())
        .subscribe((response) => {
          //console.log(response);
          this.alertCount = response;
        });
    }
  }

  startNotification(timestamp) {
    this.stopNotification();

    this.notificationsStarted = true;

    this.alertCountSuscription = timer(5000, 5000)
      .pipe(
        switchMap(() => this.restclient.getNotifications(timestamp)),
        catchError((error) => {
          console.error(error);
          return EMPTY;
        })
      )
      .subscribe((response) => {
        this.alertCount = response;
      });
  }

  stopNotification() {
    if (this.alertCountSuscription) {
      this.alertCountSuscription.unsubscribe();
      this.alertCountSuscription = undefined;
    }

    this.notificationsStarted = false;
  }

  startSegeditNotification(eventId) {
    if (this.segEditNotifications == undefined) {
      this.alertCountSuscription = this.restclient
        .getSegeditNotifications(eventId)
        .pipe(
          delay(3000),
          repeat(),
          takeWhile((val) => this.condicion(val))
        )
        .subscribe(
          () => { },
          () => { },
          () => {
            if (this.cookieService.check('segEditProfile')) {
              this.cookieService.delete('segEditProfile');
            }

            //this.hideWaiting();
            //this.getData(MAIN);
          }
        );
    }
  }

  condicion(val: any): boolean {
    if (val === 1) {
      return true;
    } else {
      return false;
    }
  }
}
